export default "__VITE_ASSET__CpNb94jt__"